import { BgColorsOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { FC } from 'react'
import styled from 'styled-components'

interface ColorProofIndicatorProps {
    title?: string
}

const ColorProofIndicator: FC<ColorProofIndicatorProps> = ({
    title = 'Цветопроба',
}) => (
    <Tooltip title={title}>
        <Icon />
    </Tooltip>
)

const Icon = styled(BgColorsOutlined)`
    color: #d71868;
    font-size: 16px;
`

export default ColorProofIndicator
